import { WORLD_KEYS } from '../types';

import type { WorldKey } from '../types';

type Random = () => number;

function shuffleWorlds(random: Random): WorldKey[] {
	const worlds = [...WORLD_KEYS];
	for (let index = worlds.length - 1; index > 0; index -= 1) {
		const swapIndex = Math.floor(random() * (index + 1));
		[worlds[index], worlds[swapIndex]] = [worlds[swapIndex], worlds[index]];
	}
	return worlds;
}

export function createWorldSequence(
	levelCount: number,
	firstWorld: WorldKey | null = null,
	random: Random = Math.random,
): WorldKey[] {
	const sequence: WorldKey[] = [];
	while (sequence.length < levelCount) {
		const batch = shuffleWorlds(random);
		if (sequence.length === 0 && firstWorld) {
			const firstWorldIndex = batch.indexOf(firstWorld);
			[batch[0], batch[firstWorldIndex]] = [batch[firstWorldIndex], batch[0]];
		}
		const previousWorld = sequence.at(-1);
		if (previousWorld === batch[0]) {
			const replacementIndex = batch.findIndex((world) => world !== previousWorld);
			[batch[0], batch[replacementIndex]] = [batch[replacementIndex], batch[0]];
		}
		sequence.push(...batch.slice(0, levelCount - sequence.length));
	}
	return sequence;
}
